export default function verifyDevelopmentEnv() {
  return (
    process?.env?.NODE_ENV === 'development' || localStorage.getItem('devMode')
  );
}
